import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/DoubleSpeedIncreasingTransmission/1_1x.png`;
const Pic2 = `${FullPath}/DoubleSpeedIncreasingTransmission/2_1x.png`;
const Pic3 = `${FullPath}/DoubleSpeedIncreasingTransmission/3_1x.png`;
const Pic4 = `${FullPath}/DoubleSpeedIncreasingTransmission/4_1x.png`;
const Pic5 = `${FullPath}/DoubleSpeedIncreasingTransmission/5_1x.png`;
const Pic6 = `${FullPath}/DoubleSpeedIncreasingTransmission/6_1x.png`;
const Pic7 = `${FullPath}/DoubleSpeedIncreasingTransmission/7_1x.png`;
const Pic8 = `${FullPath}/DoubleSpeedIncreasingTransmission/8_1x.png`;
const Pic9 = `${FullPath}/DoubleSpeedIncreasingTransmission/9_1x.png`;
const Pic10 = `${FullPath}/DoubleSpeedIncreasingTransmission/10_1x.png`;
const Pic11 = `${FullPath}/DoubleSpeedIncreasingTransmission/11_1x.png`;
const Pic12 = `${FullPath}/DoubleSpeedIncreasingTransmission/12_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}